import environment from "../../../env";

const serviceBaseURLs =
  environment.backendType === "firebase"
    ? environment.service[environment.env]
    : environment.service[environment.env]["china"];

export const servicesMapping = Object.entries(serviceBaseURLs).reduce((acc, [k, v]) => ({ ...acc, [v]: k }), {});
